/* src/app/core/components/tabs/tabs.component.scss */
:host {
  display: block;
}
/*# sourceMappingURL=tabs.component.css.map */
